import { ReactNode } from "react";
import styled from "@emotion/styled";

import { ButtonType } from "components/ui/button/Button";
import Checkbox from "components/ui/checkbox/Checkbox";
import { DropdownMenu, DropdownMenuItem, DropdownMenuTrigger } from "components/ui/dropdown_menu";
import { useBidResponseWorkflow } from "lib/hooks/api/bid/bid_responses/useBidResponseWorkflow";
import { BidResponseStageOptionRenderer } from "./stageSelectUtils";
import { processBidResponseTransitions } from "./utils";

type Props = {
  buttonContent: ReactNode;
  buttonType: ButtonType;
  loading?: boolean;
  onClick: (selectedStage: string) => void;
  chevron: boolean;
  selectedIds?: string[];
  showCheckBox: boolean;
};
export function BidResponseStageButton({
  buttonContent,
  buttonType,
  loading,
  onClick,
  chevron,
  selectedIds,
  showCheckBox,
}: Props) {
  const { data } = useBidResponseWorkflow();
  const transitions = data ? processBidResponseTransitions(data.transitions) : [];

  return (
    <DropdownMenu
      width={200}
      trigger={
        <DropdownMenuTrigger
          icon="alignTop02"
          buttonType={buttonType}
          loading={loading}
          hideArrow={!chevron}
        >
          {buttonContent}
        </DropdownMenuTrigger>
      }
    >
      {transitions.map((transition) => (
        <DropdownContainer key={transition.label}>
          <GroupTitle>{transition.label}</GroupTitle>
          <div>
            {transition.options.map((option) => (
              <MenuItem
                key={option.value}
                onClick={() => onClick(option.value)}
                isSelected={selectedIds?.includes(option.value)}
              >
                {showCheckBox && (
                  <Checkbox
                    checked={selectedIds?.includes(option.value)}
                    aria-label={`Toggle ${option.label} stage`}
                  />
                )}
                <BidResponseStageOptionRenderer
                  label={option.label}
                  value={String(option.value || "")}
                  options={transitions}
                />
              </MenuItem>
            ))}
          </div>
        </DropdownContainer>
      ))}
    </DropdownMenu>
  );
}

const DropdownContainer = styled.div({
  width: "100%",
});

const MenuItem = styled(DropdownMenuItem)<{ isSelected?: boolean }>(({ isSelected, theme }) => ({
  padding: "0px 16px",
  ...(isSelected && {
    background: theme.colors.sysPrimarySubtle,
  }),
}));

const GroupTitle = styled.div({
  fontSize: 12,
  padding: "5px 12px",
  color: "rgba(0, 0, 0, 0.45)",
  transition: "all 0.2s",
});
